<template>
    <div v-if="astable">
        <d-row class="table" :class="'placeholder-' + mode" v-for="r in parseInt(rows)" :key="r">
            <d-col v-for="c in parseInt(cols)" :key="c">
                <span class="placeholder" :style="_style">&nbsp;</span>
            </d-col>
        </d-row>
    </div>
    <span v-else :class="'placeholder-' + mode">
        <span class="placeholder" :class="width" :style="_style">&nbsp;<span style="visibility:hidden;">
                <slot></slot>
            </span></span>
    </span>
</template>

<script setup>

import { computed, defineProps, toRefs } from 'vue';

const props = defineProps({
    variant: { type: String, default: "primary" },
    height: { type: [Number, String], default: null },
    width: { type: [Number, String], default: null },
    full: { type: Boolean, default: false },
    mode: { type: String, default: 'wave' },
    astable: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 2 },
    cols: { type: [Number, String], default: 3 }
})

const { full, variant, width, height, astable } = toRefs(props)

const width_style = computed(() => {
    if (full.value || astable.value)
        return "width: 100%;";
    else if (width.value)
        return 'width:' + fixStyleValue(width.value) + ";";
    return "";
})
const height_style = computed(() => {
    if (height.value)
        return 'height:' + fixStyleValue(height.value) + ";";
    return "";
})
const background_style = computed(() => "background-color: var(--bs-" + variant.value + ")")
const _style = computed(() => width_style.value + height_style.value + background_style.value)

function fixStyleValue(value) {
    var style_value = "";
    if (isNaN(value)) {
        style_value = value;
    }
    else {
        style_value = value + "px";
    }
    return style_value;
}

</script>
